import type {Configtype} from './type';
const config: Configtype = {
	enabled: true,
	hasborder: true,
	heightLight: false,
	maxDepth: 12,
	use: {
		production: false
	},
	img: {
		maxHeight: 300,
		maxWidth: 400,
	},
	base: {
		title: 'Base',
		titleColor: 'white',
		contentColor: 'grey',
		backgroundColor: 'grey',
		borderColor: 'grey',
	},
	info: {
		title: 'Info',
		titleColor: 'white',
		contentColor: 'grey',
		backgroundColor: 'grey',
		borderColor: 'grey',
	},
	error: {
		title: 'error',
		titleColor: 'white',
		contentColor: 'red',
		backgroundColor: 'red',
		borderColor: 'red',
	},
	success: {
		title: 'success',
		titleColor: 'white',
		contentColor: 'green',
		backgroundColor: 'green',
		borderColor: 'green',
	},
	warning: {
		title: 'warn',
		titleColor: 'white',
		contentColor: 'orange',
		backgroundColor: 'orange',
		borderColor: 'orange',
	},
	equal: {},
};
export default config;
